module.exports = __webpack_public_path__ + "static/media/simulation-percentage-info.c2ea4e68.svg";